import { UncontrolledTooltip } from 'reactstrap';
import './SideNavTooltip.scss';

interface ISideNavTooltip {
    targetId: string;
    label: string;
    enabled: boolean;
}

const SideNavTooltip = ({ targetId, label, enabled }: ISideNavTooltip) => {
    if (!enabled) {
        return null;
    }
    return (
        <UncontrolledTooltip
            target={targetId}
            placement="left"
            hideArrow
            fade={false}
            popperClassName="SideNavTooltip"
            offset="0, 12"
            modifiers={{ preventOverflow: { boundariesElement: 'viewport' } }}
            delay={{ show: 200, hide: 0 }}
        >
            {label}
        </UncontrolledTooltip>
    );
};

export default SideNavTooltip;
